// extracted by mini-css-extract-plugin
module.exports = {"signInSignUp":"shared-style_signInSignUp__H0hSB","click_link":"shared-style_click_link__nUzpP"};